import React from 'react';
import PropTypes from 'prop-types';
import { getScheduleFields } from './options';
import fieldSelection from '../../../../components/Forms/Fields';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    flexWrap: 'wrap',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

const Form = ({ formProps, taskType }) => {
  const { values } = formProps;
  const classes = useStyles();

  const fields = getScheduleFields({
    taskType,
    activeTab: values.schedule ? values.schedule.activeTab : '',
  });
  return (
    <div className={classes.root}>
      {fields.map((field, index) => {
        return fieldSelection({ item: field, key: index, props: formProps });
      })}
    </div>
  );
};

Form.propTypes = {
  formProps: PropTypes.object,
  taskType: PropTypes.string,
};

export default Form;
